(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  let trigger, previousOverflow, busy = false, closing = false;
  const error = message => { const node = drawer.querySelector('.drawer-error'); node.textContent = message; node.hidden = false; };
  const refresh = async () => {
    const response = await fetch(`${root}cart?section_id=nw-cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to load your bag. Please try again.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = html.querySelector('.drawer-content');
    if (!content) throw new Error('Unable to load your bag. Please view the full bag.');
    drawer.replaceChildren(content);
    document.querySelectorAll('.bag-link span').forEach(node => { node.textContent = `(${content.dataset.count})`; });
  };
  const open = async source => {
    if (closing) return;
    if (!drawer.open) {
      trigger = source || document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      drawer.showModal();
      document.documentElement.style.overflow = 'hidden';
      drawer.querySelector('[data-bag-close]').focus();
    }
    if (busy) return;
    busy = true; drawer.setAttribute('aria-busy', 'true');
    try { await refresh(); drawer.querySelector('[data-bag-close]').focus(); }
    catch (e) { error(e.message); }
    finally { busy = false; drawer.removeAttribute('aria-busy'); }
  };
  const close = () => {
    if (closing || !drawer.open) return;
    closing = true; drawer.classList.add('is-closing');
    setTimeout(() => { drawer.close(); drawer.classList.remove('is-closing'); closing = false; }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
  };
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('click', async event => {
    if (event.target.closest('[data-bag-close]')) { close(); return; }
    if (event.target === drawer) { const r = drawer.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right) close(); return; }
    const button = event.target.closest('[data-bag-quantity]');
    if (!button || busy) return;
    const line = button.closest('[data-line-key]');
    const key = line.dataset.lineKey;
    busy = true; drawer.setAttribute('aria-busy','true');
    drawer.querySelectorAll('[data-bag-quantity],.drawer-checkout').forEach(b => b.disabled = true);
    try {
      const response = await fetch(`${root}cart/change.js`, { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:key,quantity:Number(button.dataset.bagQuantity)}) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update this item.');
      const top = drawer.querySelector('.drawer-items')?.scrollTop || 0;
      await refresh();
      const items = drawer.querySelector('.drawer-items'); if(items) items.scrollTop = top;
      const next = [...drawer.querySelectorAll('[data-line-key]')].find(e => e.dataset.lineKey === key);
      (next?.querySelector('[data-bag-quantity]') || drawer.querySelector('[data-bag-close]')).focus({preventScroll:true});
    } catch (e) { error(e.message); }
    finally { busy=false;drawer.removeAttribute('aria-busy');drawer.querySelectorAll('[data-bag-quantity],.drawer-checkout').forEach(b=>b.disabled=false); }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.bag-link');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); open(link);
  });
  window.TayacueCart = {open};
})();
